import React from 'react';
import { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import colors from '../../utils/colors';
import { assetPath } from '../../utils/folders';
import { Tooltip } from './Tooltip';
import { useSelector } from 'react-redux';

import './PlusSign.scss';

export const PlusSign = ({ clickAction, savedState, selectedState, isDocrio, partialSelection }) => {
  const objectTag = useRef(null);
  const [itemHover, setItemHover] = useState(false);
  const isNavigatingFolders = useSelector((state) => state.folders.isNavigatingFolders);
  const isChangingFolder = useSelector((state) => state.mail.isChangingEmailSaveLocation);
  const isAddingAttendee = useSelector((state) => state.calendar?.addingAttendee);
  const tooltipContent = isChangingFolder ? 'Select Folder' :
                          isNavigatingFolders ? 'Select File' :
                          isAddingAttendee ? 'Select Attendee' :
                          `Save to ${isDocrio ? 'Docrio' : 'Litify'}`;

  useEffect(() => {
    setFillColor();
  }, [itemHover]);

  const setFillColor = () => {
    window.requestAnimationFrame(() => {
      const doc = objectTag.current?.contentDocument;
      const svg = doc?.querySelector('svg');
      if (svg?.querySelector('style')) {
        svg.querySelector('style').textContent = `path { fill: ${itemHover && colors.white}; } rect { stroke: ${itemHover && !selectedState && colors.slateBlue}; fill: ${itemHover && !selectedState && colors.slateBlue}; } }`;
      } else if (svg) {
        const styleElement = doc.createElementNS('http://www.w3.org/2000/svg', 'style');
        svg.appendChild(styleElement);
      }
    });
  };

  return (
    <div className={`plus-sign plus-sign-container ${savedState ? 'plus-sign-defaultCursor' : ''}`} >
      <span className={`plus-sign`}
        onMouseEnter={() => setItemHover(true)}
        onMouseOut={() => setItemHover(false)}
        onClick={clickAction}
      >
        <Tooltip textContent={tooltipContent}>
          <object
            ref={objectTag}
            className={`plus-sign plus-sign-icon`}
            onLoad={setFillColor}
            data={
              savedState ?
                assetPath('/assets/checkedInactive.svg') :
                partialSelection ?
                  assetPath('/assets/checkedPartial.svg') :
                  selectedState ?
                    assetPath('/assets/checkedActive.svg') :
                    assetPath('/assets/plusSignActive.svg')}
            type='image/svg+xml'
          />
        </Tooltip>
      </span>
    </div>
  );
};

PlusSign.propTypes = {
  clickAction: PropTypes.func,
  savedState: PropTypes.bool,
  selectedState: PropTypes.bool,
  isHoveringParent: PropTypes.bool,
  isDocrio: PropTypes.bool,
  partialSelection: PropTypes.bool,
};
